import React from 'react';
import { Navigate } from 'react-router-dom';
import { useMerchantAuth } from '../../contexts/AuthContext';

/**
 * Wraps a route element and redirects to /dashboard if the user lacks the required permission(s).
 * @param {string|string[]} permission - Single permission key or array (user needs any one)
 */
export default function RequirePermission({ permission, children }) {
    const { hasPermission } = useMerchantAuth();
    const allowed = Array.isArray(permission)
        ? permission.some((p) => hasPermission(p))
        : hasPermission(permission);
    if (!allowed) {
        return <Navigate to="/dashboard" replace />;
    }
    return children;
}
